import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

import Playground from './pages/manage-agent/inc/Playground';
import AccessKeyPage from './pages/settings/inc/AccessKey';
import Settings from './pages/settings/index';
import { AdminRoutes } from './routes/AdminRoutes';
import { CustomerRoutes } from './routes/CustomerRoutes';
import { SupervisorRoutes } from './routes/SupervisorRoutes';
import { hasGroup } from './helper';

const CustomerDashboard = React.lazy(() => import('./pages/dashboard/CustomerDashboard'));
const ResetPassword = React.lazy(() => import('./pages/forgot-pass/ResetPassword'));
const PublicLayout = React.lazy(() => import('./layouts/public/PublicLayout'));
const DashboardLayout = React.lazy(() => import('./layouts/dashboard'));
const ComingSoon = React.lazy(() => import('./pages/coming-soon/ComingSoon'));
const ForgetPassword = React.lazy(() => import('./pages/forgot-pass/ForgotPassword'));
const CustomerProfile = React.lazy(() => import('./pages/profile/CustomerProfile'));
const Login = React.lazy(() => import('./pages/Login'));
const Register = React.lazy(() => import('./pages/Register'));
const EmbeddedChatBox = React.lazy(() => import('./pages/chat/EmbeddedChatBox'));
const Embedding = React.lazy(() => import('./pages/manage-agent/inc/Embedding'))
const AddBot = React.lazy(() => import("./pages/chat-bots/AddBot"))
const ManageAgent = React.lazy(() => import("./pages/manage-agent"));

// ----------------------------------------------------------------------

export const children = () => {
    const dashboardChildrens = [
        { path: '', element: <CustomerDashboard />, name: 'Dashboard', title: 'Dashboard', icon: 'mdi:view-dashboard' },
        { title: 'Profile', path: 'profile', element: <CustomerProfile />, name: 'Profile', icon: 'mdi:account' },

        { path: 'my-agents/chat-bots/:chatbotId', element: <ManageAgent />, name: 'Manage Agent', title: 'Manage Agent' },
        { path: 'my-agents/playground/:chatbotId', element: <Playground />, name: 'Playground', title: 'Playground' },
        { path: 'my-agents/chat-bots/add', element: <AddBot />, name: "addNewBot", title: "Add New Agent" },
        { path: 'embedding/:chatbotId', element: <Embedding />, name: 'Knowledge', title: 'Knowledge' },

        { path: 'settings', element: <Settings />, name: 'settings', title: 'Settings' },
        { path: 'settings/access-key', element: <AccessKeyPage />, name: 'access-key', title: 'Access Key' },
        

    ];
    if (hasGroup("USER")) dashboardChildrens.push(...CustomerRoutes);
    if (hasGroup("ADMIN")) dashboardChildrens.push(...AdminRoutes);
    if (hasGroup("SUPERVISOR")) dashboardChildrens.push(...SupervisorRoutes);

    console.log('routes',dashboardChildrens);
    return dashboardChildrens;
};
export default function Router() {
    // const isAuthenticated = localStorage.getItem(TOKEN)?true:false
    return useRoutes([
        {
            path: '/',
            // element: <LogoOnlyLayout />,
            element: <Navigate to={'/dashboard'} state={{"from":"root"}} />,
            // children: [
            //   { path: '/', element: <Navigate to={localStorage.getItem(TOKEN) ? "/dashboard/app" : "/login"}/> },
            //   { path: '404', element: <NotFound /> },
            //   { path: '*', element: <Navigate to="/404" /> },
            // ],
        },
        {
            path: 'auth',
            element: <PublicLayout />,
            children: [
                {
                    path: 'login',
                    name: 'Login',
                    element: <Login />,
                },
                {
                    path: 'register',
                    name: 'Register',
                    element: <Register />,
                },
                {
                    path: 'forget-password',
                    name: 'Forgot Password',
                    element: <ForgetPassword />,
                },
                {
                    path: 'reset-password',
                    name: 'Reset Password',
                    element: <ResetPassword />,
                },
            ],
        },
        {
            path: 'dashboard',
            element: <DashboardLayout />,
            children: [...children()],
        },
        {
            path: 'coming-soon',
            element: <ComingSoon />,
        },
        {
            path: 'embedded-chat/:chatbotID/:token',
            element: <EmbeddedChatBox />,
        },
        {
            path: '*',
            element: <Navigate to="/404" />,
        },
    ]);
}
